'use client';

import Image from '@/components/Image';
import { UlikeSectionBlock } from '../types';
import { useValidExposure } from '@/hooks/useValidExposure';
import { useCallback } from 'react';

interface UlikeSectionProps {
  isWeb: boolean;
  content: UlikeSectionBlock;
  index: number;
  trackADExp: (
    moduleName: string,
    pitsIndex: number,
    pitsJumpType?: string,
    pitsJumpContent?: string,
  ) => void;
  trackADClick: (
    moduleName: string,
    pitsIndex: number,
    pitsJumpType?: string,
    pitsJumpContent?: string,
  ) => void;
}

export function UlikeSection({
  isWeb,
  content,
  index,
  trackADExp,
  trackADClick,
}: UlikeSectionProps) {
  const {
    pc_image,
    mobile_image,
    pc_width,
    pc_height,
    mobile_width,
    mobile_height,
    image_alt,
    url,
    module_name,
  } = content;

  const { ref: validExposureRef } = useValidExposure({
    callback: useCallback(() => {
      trackADExp(module_name, index, url ? '4' : '0', url || undefined);
    }, [module_name, index, trackADExp, url]),
  });

  const handleClick = useCallback(() => {
    trackADClick(module_name, index, url ? '4' : '0', url || undefined);
  }, [module_name, index, trackADClick, url]);

  return (
    <a
      ref={validExposureRef}
      href={url}
      onClick={handleClick}
      className="relative w-full overflow-hidden text-white"
      target="_blank"
      rel="noopener noreferrer"
      aria-label={image_alt}
    >
      <Image
        src={pc_image}
        alt={image_alt}
        className="w-full h-full object-cover lg:block hidden"
        width={pc_width}
        height={pc_height}
      />
      <Image
        src={mobile_image}
        alt={image_alt}
        className="w-full h-full object-cover lg:hidden block"
        width={mobile_width}
        height={mobile_height}
      />
    </a>
  );
}
